import AssessmentIcon from "../../assets/icons/notification/assessment.svg";
import BadgeIcon from "../../assets/icons/notification/badge.svg";
import BullpenIcon from "../../assets/icons/notification/bullpen.svg";
import BullpenNewEventIcon from "../../assets/icons/notification/bullpen-new-event.svg";
import BullpenSavedIcon from "../../assets/icons/notification/bullpen-saved.svg";
import CertificateIcon from "../../assets/icons/notification/certificate.svg";
import ChallengeIcon from "../../assets/icons/notification/challenge.svg";
import ChallengeCompletedIcon from "../../assets/icons/notification/challenge-completed.svg";
import ChallengeDeadlineApproachingIcon from "../../assets/icons/notification/challenge-deadline-appoaching.svg";
import ChallengeMissedIcon from "../../assets/icons/notification/challenge-missed.svg";
import CoinsRedIcon from "../../assets/icons/notification/coins-red.svg";
import CompetitionIcon from "../../assets/icons/notification/competition.svg";
import CompetitionCompletedIcon from "../../assets/icons/notification/competition-completed.svg";
import EventIcon from "../../assets/icons/notification/event.svg";
import EventNewIcon from "../../assets/icons/notification/event-new.svg";
import JobIcon from "../../assets/icons/notification/job.svg";
import JobFavoriteIcon from "../../assets/icons/notification/job-favorite.svg";
import JobNewIcon from "../../assets/icons/notification/job-new.svg";
import JournalIcon from "../../assets/icons/notification/journal.svg";
import MedalIcon from "../../assets/icons/notification/medal.svg";
import ModuleIcon from "../../assets/icons/notification/module.svg";
import ModuleCompletedIcon from "../../assets/icons/notification/module-completed.svg";
import ModuleSavedIcon from "../../assets/icons/notification/module-saved.svg";
import ProfileIcon from "../../assets/icons/notification/profile.svg";
import ProjectIcon from "../../assets/icons/notification/project.svg";
import QuestionMarkIcon from "../../assets/icons/notification/question-mark.svg";
import ReportIcon from "../../assets/icons/notification/report.svg";
import ResourceAddedIcon from "../../assets/icons/notification/resource-added.svg";
import ResourceUnlockedIcon from "../../assets/icons/notification/resource-unlocked.svg";
import RewardPersonIcon from "../../assets/icons/notification/reward-person.svg";
import RewardTickMarkIcon from "../../assets/icons/notification/reward-tick-mark.svg";
import TickMarkIcon from "../../assets/icons/notification/tick-mark.svg";

import {
  SHARED_PLATFORM_ROUTES as PLATFORM_ROUTES,
  AscRoundedTagTypes,
  NotificationType,
} from "@ascendnow/shared";

interface INotificationTypeHandler {
  route?: string;
  tag: AscRoundedTagTypes;
  icon: string;
}

export function notificationTypeHandler(
  type: NotificationType,
  body?: {
    [key: string]: string;
  }
): INotificationTypeHandler {
  switch (type) {
    case NotificationType.MODULE_STARTED:
      return {
        route: `${PLATFORM_ROUTES.module}${
          body && body["moduleId"] ? "/" + body["moduleId"] : ""
        }`,
        tag: "tag",
        icon: ModuleIcon,
      };
    case NotificationType.MODULE_SAVED:
      return {
        route: `${PLATFORM_ROUTES.module}${
          body && body["moduleId"] ? "/" + body["moduleId"] : ""
        }`,
        tag: "tag",
        icon: ModuleSavedIcon,
      };
    case NotificationType.MODULE_COMPLETED:
      return {
        route: `${PLATFORM_ROUTES.module}${
          body && body["moduleId"] ? "/" + body["moduleId"] : ""
        }`,
        tag: "tag",
        icon: ModuleCompletedIcon,
      };
    case NotificationType.BADGE_EARNED:
      return {
        route: `${PLATFORM_ROUTES.showcase_badges_and_certificates_badges}`,
        tag: "badge",
        icon: BadgeIcon,
      };
    case NotificationType.CERTIFICATE_EARNED:
      return {
        route: `${PLATFORM_ROUTES.showcase_badges_and_certificates}${
          body && body["certificateId"] ? "/" + body["certificateId"] : ""
        }`,
        tag: "tag",
        icon: CertificateIcon,
      };
    case NotificationType.JOURNAL_ENTRY_SAVED:
      return {
        route: `${PLATFORM_ROUTES.journal}`,
        tag: "tag",
        icon: JournalIcon,
      };
    case NotificationType.PROFILE_UPDATED:
      return {
        route: `${PLATFORM_ROUTES.account_profile}`,
        tag: "tag",
        icon: ProfileIcon,
      };
    case NotificationType.REPORT_SUCCESSFULLY_DOWNLOADED:
      return {
        route: `${PLATFORM_ROUTES.analysis_reports}`,
        tag: "tag",
        icon: ReportIcon,
      };
    case NotificationType.PROJECT_ADDED:
      return {
        route: `${PLATFORM_ROUTES.analysis_projects}`,
        tag: "tag",
        icon: ProjectIcon,
      };
    case NotificationType.RESOURCE_ADDED_TO_FAVORITE: {
      const resourceCategoryId = body && body["categoryId"];
      return {
        route: resourceCategoryId
          ? PLATFORM_ROUTES.resources_favorites(resourceCategoryId)
          : PLATFORM_ROUTES.resources,
        tag: "tag",
        icon: ResourceAddedIcon,
      };
    }
    case NotificationType.RESOURCE_UNLOCKED_FOR_DOWNLOAD: {
      return {
        route: `${PLATFORM_ROUTES.resources_by_category(
          body && body["categoryId"] ? "/" + body["categoryId"] : ""
        )}`,
        tag: "tag",
        icon: ResourceUnlockedIcon,
      };
    }
    case NotificationType.APPLICATION_SUBMITTED:
      return {
        route: `${PLATFORM_ROUTES.tracks_entrepreneurship_track_bullpen_application}`,
        tag: "bullpen",
        icon: BullpenIcon,
      };
    case NotificationType.APPLICATION_SAVED:
      return {
        route: `${PLATFORM_ROUTES.tracks_entrepreneurship_track_bullpen_application}`,
        tag: "bullpen",
        icon: BullpenSavedIcon,
      };
    case NotificationType.NEW_BULLPEN_EVENT:
      return {
        route: `${PLATFORM_ROUTES.tracks_entrepreneurship_track_bullpen_application}`,
        tag: "bullpen",
        icon: BullpenNewEventIcon,
      };
    case NotificationType.JOB_APPLIED: {
      const jobId = body && body["jobId"];
      return {
        route: `${PLATFORM_ROUTES.tracks_internship_track_job_board}${
          jobId ? `/${PLATFORM_ROUTES.my_applications}/${jobId}` : ""
        }`,
        tag: "tag",
        icon: JobIcon,
      };
    }
    case NotificationType.JOB_FAVORITED: {
      const jobId = body && body["jobId"];
      return {
        route: `${PLATFORM_ROUTES.tracks_internship_track_job_board}${
          jobId ? `/${PLATFORM_ROUTES.my_applications}/${jobId}` : ""
        }`,
        tag: "tag",
        icon: JobFavoriteIcon,
      };
    }
    case NotificationType.NEW_JOB_ADDED: {
      const jobId = body && body["jobId"];
      return {
        route: `${PLATFORM_ROUTES.tracks_internship_job(
          jobId ? "/" + jobId : ""
        )}`,
        tag: "tag",
        icon: JobNewIcon,
      };
    }
    case NotificationType.EVENT_CONFIRMED:
      return {
        route: `${PLATFORM_ROUTES.events}${
          body && body["eventId"] ? "/" + body["eventId"] : ""
        }`,
        tag: "tag",
        icon: EventIcon,
      };
    case NotificationType.NEW_EVENT:
      return {
        route: `${PLATFORM_ROUTES.events}${
          body && body["eventId"] ? "/" + body["eventId"] : ""
        }`,
        tag: "tag",
        icon: EventNewIcon,
      };
    case NotificationType.CHALLENGE_STARTED:
      return {
        route: `${PLATFORM_ROUTES.challenges}${
          body && body["challengeId"] ? "/" + body["challengeId"] : ""
        }`,
        tag: "challenge",
        icon: ChallengeIcon,
      };
    case NotificationType.CHALLENGE_DEADLINE_APPROACHING:
      return {
        route: `${PLATFORM_ROUTES.challenges}${
          body && body["challengeId"] ? "/" + body["challengeId"] : ""
        }`,
        tag: "challenge",
        icon: ChallengeDeadlineApproachingIcon,
      };
    case NotificationType.CHALLENGE_COMPLETE:
      return {
        route: `${PLATFORM_ROUTES.challenges}${
          body && body["challengeId"] ? "/" + body["challengeId"] : ""
        }`,
        tag: "challenge",
        icon: ChallengeCompletedIcon,
      };
    case NotificationType.CHALLENGE_FEEDBACK_RECEIVED:
      return {
        route: `${PLATFORM_ROUTES.challenges}${
          body && body["challengeId"]
            ? "/" + body["challengeId"] + "/participate"
            : ""
        }`,
        tag: "challenge",
        icon: ChallengeCompletedIcon,
      };
    case NotificationType.CHALLENGE_DEADLINE_PASSED:
      return {
        route: `${PLATFORM_ROUTES.challenges}${
          body && body["challengeId"] ? "/" + body["challengeId"] : ""
        }`,
        tag: "challenge",
        icon: ChallengeMissedIcon,
      };
    case NotificationType.WRITING_COMPETITION_OPEN:
      return {
        route: `${PLATFORM_ROUTES.challenges}${
          body && body["challengeId"] ? "/" + body["challengeId"] : ""
        }`,
        tag: "challenge",
        icon: CompetitionIcon,
      };
    case NotificationType.WRITING_COMPETITION_SUBMISSION_SUCCESSFUL:
      return {
        route: `${PLATFORM_ROUTES.challenges}${
          body && body["challengeId"] ? "/" + body["challengeId"] : ""
        }`,
        tag: "challenge",
        icon: CompetitionCompletedIcon,
      };
    case NotificationType.WRITING_COMPETITION_RESULTS_OUT:
      return {
        route: PLATFORM_ROUTES.showcase_reflection_competitions_won,
        tag: "challenge",
        icon: MedalIcon,
      };
    case NotificationType.PRIVATE_SESSION_REQUEST_SUBMITTED:
      return {
        route: PLATFORM_ROUTES.rewards_purchased,
        tag: "tag",
        icon: RewardPersonIcon,
      };
    case NotificationType.PRIVATE_SESSION_BOOKED_SUCCESSFULLY:
      return {
        route: PLATFORM_ROUTES.rewards_purchased,
        tag: "tag",
        icon: RewardTickMarkIcon,
      };
    case NotificationType.EVENT_RECORDING_PURCHASED: {
      const recordingId = body && body["recordingId"];
      const recordingType = body && body["recordingType"];
      return {
        route: `${PLATFORM_ROUTES.rewards_recordings}${
          recordingId && recordingType
            ? `/${recordingId}?type=${recordingType}`
            : ""
        }`,
        tag: "tag",
        icon: CoinsRedIcon,
      };
    }
    case NotificationType.FINISH_YOUR_BASELINE_ASSESSMENT:
      return {
        route: PLATFORM_ROUTES.dashboard_baseline_assessment,
        tag: "tag",
        icon: AssessmentIcon,
      };
    case NotificationType.BASELINE_ASSESSMENT_COMPLETE:
      return {
        route: PLATFORM_ROUTES.dashboard_baseline_assessment_results,
        tag: "tag",
        icon: AssessmentIcon,
      };
    case NotificationType.INQUIRY_SUBMITTED:
      return {
        tag: "tag",
        icon: QuestionMarkIcon,
      };
    case NotificationType.PASSWORD_CHANGED_SUCCESSFULLY:
      return {
        route: PLATFORM_ROUTES.account_profile + "?tab=change-password",
        tag: "tag",
        icon: TickMarkIcon,
      };
    default:
      return {
        route: "/",
        tag: "tag",
        icon: QuestionMarkIcon,
      };
  }
}

// | "challenge"
//   | "event"
//   | "bullpen"
//   | "badge"
//   | "tag"
//   | "points"
//   | "points-first-place"
//   | "points-second-place"
//   | "points-third-place";
